import React from 'react';
import { Row, Col, Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { File } from 'components/FileUploadMultiple';

const Comprovation = ({ data }) => {
  const { t } = useTranslation();

  const statusTask = statusId => {
    let icon = '';

    icon =
      statusId === 21 ? (
        <OverlayTrigger
          key="top"
          placement="top"
          overlay={<Tooltip id={`tooltip-top`}>{t('label:approved')}</Tooltip>}
        >
          <i style={{ color: 'green' }} className="fas fa-check-circle" />
        </OverlayTrigger>
      ) : statusId === 11 ? (
        <OverlayTrigger
          key="top"
          placement="top"
          overlay={
            <Tooltip id={`tooltip-top`}>{t('label:disapproved')}</Tooltip>
          }
        >
          <i style={{ color: 'red' }} className="fas fa-times-circle" />
        </OverlayTrigger>
      ) : (
        <OverlayTrigger
          key="top"
          placement="top"
          overlay={
            <Tooltip id={`tooltip-top`}>{t('label:awaiting approval')}</Tooltip>
          }
        >
          <i
            style={{ color: 'orange' }}
            className="fas fa-exclamation-circle"
          />
        </OverlayTrigger>
      );
    return icon;
  };

  return (
    <>
      <Row className="mt-2">
        <Col>
          <h5>{t('title:creative list approval')}</h5>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col>
          <Table bordered hover responsive>
            <thead>
              <tr>
                <th className="text-center align-middle">
                  {t('label:status')}
                </th>
                <th className="text-center align-middle">
                  {t('label:comments')}
                </th>
                <th className="text-center align-middle">
                  {t('label:additional information')}
                </th>
                <th className="text-center align-middle">
                  {t('label:approval art')}
                </th>
              </tr>
            </thead>
            <tbody>
              {data.action_comprovations.map((comprovation, k) => (
                <tr key={k}>
                  <td className="text-center align-middle">
                    {statusTask(comprovation.status_id)}
                  </td>
                  <td className="text-center align-middle">
                    {comprovation.comments_approval !== null
                      ? comprovation.comments_approval
                      : '--'}
                  </td>
                  <td className="text-center align-middle">
                    {comprovation.observation}
                  </td>
                  <td className="align-middle">
                    {comprovation.files.map(file => (
                      <File
                        key={file.id}
                        extension={file.extension}
                        comment={file.comment}
                        uri={file.uri}
                      />
                    ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </>
  );
};

export default Comprovation;
